import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Edit } from '@mui/icons-material'
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  TextareaAutosize,
} from '@mui/material'
import MDButton from 'components/MDButton'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices } from 'hook/services'
import { useUserInfo } from 'context/user'
import Multiselect from '../../MultiSelect'

const CreateModal = ({ categries, subcategories, handleRefresh }) => {
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState('')
  const [selectedCategoryObj, setSelectedCategoryObj] = useState(null) // New state for category object
  const { app_id } = useParams()
  const AppService = useAppServices()
  const [user] = useUserInfo()

  const handlemodal = () => {
    setOpenAddProduct(true)
  }

  const closeAddProduct = () => {
    setOpenAddProduct(false)
    setSelectedCategory('')
    setSelectedCategoryObj(null)
  }

  const filteredSubcategories = selectedCategory
    ? subcategories.filter((subcat) => subcat.category.value === selectedCategory)
    : []

  const AddProduct = ({ open, onClose }) => {
    const [processing, setProcessing] = useState(false)

    const handleSubmit = async (e) => {
      e.preventDefault()
      setProcessing(true)
      
      // Find the complete category object
      const categoryObj = categries.find(cat => cat.value === selectedCategory);
      
      const payload = {
        category: {
          id: categoryObj.value,
          label: categoryObj.label,
          // include any other properties you need from the category object
          ...categoryObj
        },
        subcategory:e.target?.subcategory?.value? JSON.parse(e.target?.subcategory?.value): [],
        question: e.target.question.value,
        answer: e.target.answer.value,
        type: "location",
        status: e.target.status.value,
      }
      
      const { response } = await AppService.faq.create({ payload })
      if (response) {
        setProcessing(false)
        onClose()
        handleRefresh()
      }
    }

    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 600,
      height: '80vh',
      overflowY: 'auto',
      bgcolor: 'background.paper',
      p: 4,
    }

    const handleCategoryChange = (e) => {
      const selectedValue = e.target.value;
      setSelectedCategory(selectedValue);
      
      // Find and store the complete category object
      const category = categries.find(cat => cat.value === selectedValue);
      setSelectedCategoryObj(category || null);
    }

    return (
      <MDModal open={open} onClose={onClose}>
        <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
          <MDTypography variant="h5" mb={2}>
            Faq
          </MDTypography>

          <MDBox mb={2}>
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Category
            </MDTypography>
            <MDInput
              select
              name="category"
              fullWidth
              required
              SelectProps={{ native: true }}
              value={selectedCategory}
              onChange={handleCategoryChange}
            >
              <option value="">Select Category</option>
              {categries.map((cat) => (
                <option key={cat.value} value={cat.value}>
                  {cat.label}
                </option>
              ))}
            </MDInput>
          </MDBox>

          {filteredSubcategories.length > 0 && (
            <MDBox mb={2}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Sub Category
              </MDTypography>
              <Multiselect 
                data={filteredSubcategories} 
                edit_data={[]} 
                isMulti={true} 
                name="subcategory" 
              />
            </MDBox>
          )}

          <MDBox>
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Question
            </MDTypography>
            <MDInput label="Question" name="question" fullWidth />
          </MDBox>

          <MDBox>
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Answer
            </MDTypography>
            <TextareaAutosize type="text" name="answer" minRows={3} style={{ width: '100%' }} />
          </MDBox>

          {/* <MDBox mb={2}>
            <MDTypography variant="button">Type</MDTypography>
            <MDInput
              select
              name="type"
              fullWidth
              required
              SelectProps={{ native: true }}
              defaultValue="agency"
            >
              <option value="agency">Agency</option>
              <option value="levelupmarketplace">Levelupmarketplace</option>
              <option value="appcreator">Appcreator</option>
              
            </MDInput>
          </MDBox> */}

          <MDBox mb={2}>
            <MDTypography variant="button">Status</MDTypography>
            <MDInput
              select
              name="status"
              fullWidth
              required
              SelectProps={{ native: true }}
              defaultValue="Publish"
            >
              <option value="Publish">Publish</option>
              <option value="Draft">Draft</option>
            </MDInput>
          </MDBox>

          <MDBox display="flex" justifyContent="flex-end">
            <MDButton variant="gradient" color="primary" type="button" onClick={closeAddProduct}>
              Close
            </MDButton>
            <MDButton
              variant="gradient"
              color="info"
              type="submit"
              sx={{ ml: 1 }}
              disabled={processing}
            >
              Add
            </MDButton>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }

  return (
    <>
      <MDButton color="white" size="small" variant="contained" onClick={handlemodal}>
        Create
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  )
}

export default CreateModal